import { Resource } from 'i18next';
import { ILanguageData } from './buildLanguageData';
import { ENGLISH_LANGUAGE } from './en';
import { SPANISH_LANGUAGE } from './es';
import { FRENCH_LANGUAGE } from './fr';

/**  Export forwarding  */
export * from './types';

/**
 * @const LANGUAGES
 * @description List of all languages available for UI translation
 * @comment ADD NEW LANGUAGES HERE
 */
export const LANGUAGES = [ENGLISH_LANGUAGE.language, FRENCH_LANGUAGE.language] as const;

/**
 * @const CONTENT_TEMPLATE_LANGUAGES
 * @description List of all languages available for content template translation
 * @comment Spanish is included here ONLY for content templates, specifically for the
 *          5th default review campaign template (campaign__reviews__default_5).
 *          Spanish is NOT supported for UI or company language preferences - those
 *          remain English and French only.
 */
export const CONTENT_TEMPLATE_LANGUAGES = [
    ENGLISH_LANGUAGE.language,
    FRENCH_LANGUAGE.language,
    SPANISH_LANGUAGE.language,
] as const;

/**
 * @const RESOURCES
 * @description i18next-compatible Resource object containing all language data
 * @comment ADD NEW LANGUAGES HERE
 */
export const RESOURCES = buildResourceFromLanguageDataList(
    ENGLISH_LANGUAGE,
    FRENCH_LANGUAGE,
    SPANISH_LANGUAGE
);

/**
 * @const NAMESPACES
 * @description i18next namespace list
 */
export const NAMESPACES = Object.keys(ENGLISH_LANGUAGE.namespaces);

/**
 * @function buildResourceFromLanguageDataList
 * @description Build an i18next-compatible Resource object from a list of ILanguageData objects
 */
function buildResourceFromLanguageDataList(...languages: Array<ILanguageData>): Resource {
    return languages.reduce((acc, { language, namespaces }) => {
        return {
            ...acc,
            [language]: namespaces,
        };
    }, {});
}
